import { Empty } from "antd";
import { useNavigate } from "react-router";
import { useGetCoursesQuery } from "../../../../app/features/courses/courses.api";
import CourseItem from "../../../../components/ui/CourseItem";
import CourseItemSkeleton from "../../../../components/ui/CourseItemSkeleton";
import Title from "../../../../components/ui/Title";
import useError from "../../../../hooks/useError";

export default function ResentCourse() {
  const navigate = useNavigate();
  const { data, isLoading, error } = useGetCoursesQuery({});
  useError(error, "কোর্স সমূহ লোড করা যায়নি");

  return (
    <>
      <Title className="text-2xl mt-8 mb-6">সম্প্রতি কোর্স</Title>

      <div className="grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 gap-6 mb-8">
        {isLoading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <CourseItemSkeleton key={index} />
          ))
        ) : data?.length ? (
          data?.map((el) => {
            const course = el?.Course;

            return (
              <CourseItem
                key={course?.id}
                img={course?.thumbnailUrl}
                title={course?.title}
                category={course?.Category?.name}
                description={course?.description}
                price={course?.price}
                offerPrice={course?.offerPrice}
                tags={course?.CourseTag?.map((tag) => ({
                  title: tag.Tag?.name,
                  icon: undefined,
                }))}
                id={course?.id}
                onMoreButton={() => navigate(`courses/${course?.id}`)}
                moreBtnText="কোর্স দেখুন"
                courseUuid={course?.uuid}
              />
            );
          })
        ) : (
          <div className="xl:col-span-3 md:col-span-2 py-5">
            <Empty description="কোর্স সমূহ পাওয়া যায়নি" />
          </div>
        )}
      </div>
    </>
  );
}
